module.exports = __webpack_public_path__ + "media/images/sosial_media/wa-full-c-87f526192fd968747cdea2668b7a53cd.png";